// src/pages/Blog.js
import React from "react";
import { Link } from "react-router-dom";
import blogArticles from "../data/blogArticles";
import "./Blog.css";
import useSEO from "../hooks/useSEO";

function formatDate(dateStr) {
  return new Date(dateStr).toLocaleDateString("fr-FR", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

export default function Blog() {
  useSEO("/blog");
  const sortedArticles = [...blogArticles].sort(
    (a, b) => new Date(b.date) - new Date(a.date)
  );

  return (
    <div className="blog-page">
      <header className="blog-header">
        <h1>Blog Cyber-Guard</h1>
        <p>
          Conseils pratiques en cybersécurité pour les PME : sensibilisation,
          conformité, sécurité technique.
        </p>
      </header>

      <div className="blog-list">
        {sortedArticles.map((article) => (
          <Link
            to={`/blog/${article.slug}`}
            key={article.slug}
            className="blog-card"
          >
            <span className="blog-card-category">{article.category}</span>
            <h2>{article.title}</h2>
            <p className="blog-card-excerpt">{article.excerpt}</p>
            <div className="blog-card-meta">
              <span>{formatDate(article.date)}</span>
              <span>·</span>
              <span>{article.readingTime} de lecture</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
